// import something here
import Vuelidate from "vuelidate"; // "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/cli-documentation/boot-files#Anatomy-of-a-boot-file

export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.use(Vuelidate);
});